/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingId } from "../../commons/types/OnboardingId";
export const OnboardingDatapointCreate = core.serialization.object({
    onboardingId: OnboardingId,
    source: core.serialization.string().optional(),
    data: core.serialization.any(),
});
